import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "popup-dialog flex transition-all max-w-[550px] min-h-full items-center mx-auto" }
const _hoisted_2 = { class: "trezo-card w-full bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_3 = { class: "trezo-card-header bg-gray-50 dark:bg-[#15203c] mb-[20px] md:mb-[25px] flex items-center justify-between -mx-[20px] md:-mx-[25px] -mt-[20px] md:-mt-[25px] p-[20px] md:p-[25px] rounded-t-md" }
const _hoisted_4 = { class: "trezo-card-title" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "trezo-card-subtitle" }
const _hoisted_7 = { class: "trezo-card-content" }
const _hoisted_8 = { class: "sm:grid sm:grid-cols-2 sm:gap-[25px]" }
const _hoisted_9 = { class: "sm:col-span-2 mb-[20px] sm:mb-0" }
const _hoisted_10 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_11 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_12 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_13 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_14 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_15 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_16 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_17 = { class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500" }
const _hoisted_18 = { selected: "" }
const _hoisted_19 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_20 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_21 = { class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500" }
const _hoisted_22 = { selected: "" }
const _hoisted_23 = { value: "1" }
const _hoisted_24 = { value: "2" }
const _hoisted_25 = { class: "sm:col-span-2 mb-[20px] sm:mb-0" }
const _hoisted_26 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_27 = { id: "fileUploader" }
const _hoisted_28 = { class: "relative flex items-center justify-center overflow-hidden rounded-md py-[48px] px-[20px] border border-gray-200 dark:border-[#172036]" }
const _hoisted_29 = { class: "flex items-center justify-center" }
const _hoisted_30 = { class: "leading-[1.5]" }
const _hoisted_31 = { class: "text-black dark:text-white" }
const _hoisted_32 = { class: "mt-[20px] md:mt-[25px] ltr:text-right rtl:text-left" }
const _hoisted_33 = {
  type: "button",
  class: "inline-block bg-primary-500 text-white py-[12px] px-[26.5px] transition-all rounded-md hover:bg-primary-400"
}
const _hoisted_34 = { class: "inline-block relative ltr:pl-[25px] rtl:pr-[25px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'add-new-popup z-[999] fixed transition-all inset-0 overflow-x-hidden overflow-y-auto lg:py-[20px]',
      { active: _ctx.stateStoreInstance.active },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.directT('crm.contacts.addContact')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "text-[23px] transition-all leading-none text-black dark:text-white hover:text-primary-500",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "ri-close-fill" }, null, -1)
            ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.directT('crm.contacts.name')), 1),
                _cache[3] || (_cache[3] = _createElementVNode("input", {
                  type: "text",
                  class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                  placeholder: "E.g. Olivia"
                }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.directT('crm.contacts.email')), 1),
                _cache[4] || (_cache[4] = _createElementVNode("input", {
                  type: "text",
                  class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                  placeholder: "E.g. olivia@clickai.live"
                }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.directT('crm.contacts.phone')), 1),
                _cache[5] || (_cache[5] = _createElementVNode("input", {
                  type: "text",
                  class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                  placeholder: "E.g. +023-244-1234"
                }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.directT('crm.contacts.company')), 1),
                _createElementVNode("select", _hoisted_17, [
                  _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.directT('crm.contacts.select')), 1),
                  _cache[6] || (_cache[6] = _createStaticVNode("<option value=\"1\">ABC Corporation</option><option value=\"2\">XYZ Ltd</option><option value=\"3\">Tech Solutions</option><option value=\"4\">Global Solutions</option><option value=\"5\">Acma Industries</option><option value=\"6\">Synergy Ltd</option>", 6))
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.directT('crm.contacts.status')), 1),
                _createElementVNode("select", _hoisted_21, [
                  _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.directT('crm.contacts.select')), 1),
                  _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.directT('crm.contacts.active')), 1),
                  _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.directT('crm.contacts.deactive')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.directT('common.image')), 1),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "w-[35px] h-[35px] border border-gray-100 dark:border-[#15203c] flex items-center justify-center rounded-md text-primary-500 text-lg ltr:mr-[12px] rtl:ml-[12px]" }, [
                        _createElementVNode("i", { class: "ri-upload-2-line" })
                      ], -1)),
                      _createElementVNode("p", _hoisted_30, [
                        _createElementVNode("strong", _hoisted_31, _toDisplayString(_ctx.directT('crm.contacts.clickToUpload')), 1),
                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.contacts.fileHere')), 1)
                      ])
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("input", {
                      type: "file",
                      id: "fileInput",
                      class: "absolute top-0 left-0 right-0 bottom-0 rounded-md z-[1] opacity-0 cursor-pointer"
                    }, null, -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                type: "button",
                class: "rounded-md inline-block transition-all font-medium ltr:mr-[15px] rtl:ml-[15px] px-[26.5px] py-[12px] bg-danger-500 text-white hover:bg-danger-400",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
              }, _toDisplayString(_ctx.directT('crm.contacts.cancel')), 1),
              _createElementVNode("button", _hoisted_33, [
                _createElementVNode("span", _hoisted_34, [
                  _cache[10] || (_cache[10] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2" }, " add ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.contacts.create')), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}